module.exports = __webpack_public_path__ + "static/img/clickin5.abf254aa.png";